import './tailwind.css';
import React, { Suspense } from 'react';

import { BrowserRouter as Router } from 'react-router-dom';
import GlobalKeyboardHandler from './hooks/GlobalKeyboardHandler';
import { IdleTimerProvider } from './hooks/useIdleTimerContext';
import AppRoutes from './routes/AppRoutes';

export default function App() {
  return (
    <Suspense fallback={<div>laden...</div>}>
      <Router basename={'/'}>
        <IdleTimerProvider>
          {/* Globaler Tastendruck-Handler */}
          <GlobalKeyboardHandler />
          <AppRoutes />
        </IdleTimerProvider>
      </Router>
    </Suspense>
  );
}
